<div>
  <ng-container
    [ngTemplateOutlet]="this.modalTrigger?.templateRef || default_trigger"
    [ngTemplateOutletContext]="{ toggle: getToggleContent() }"
  ></ng-container>

  <div class="modal-content">
    @if (isContentVisible) {
      <ng-container
        [ngTemplateOutlet]="this.modalContent?.templateRef || default_content" [ngTemplateOutletContext]="{ close: getCloseContent() }"
      ></ng-container>
    }

  </div>
</div>

<ng-template #default_trigger><button class="button">Click Me</button></ng-template>
<ng-template #default_content
  ><div><p>Default Content</p></div></ng-template
  >
